import React from 'react';
import RatesForm from './RatesForm'; // Adjust path
import { useParams } from 'react-router-dom';

const EditRatePage = () => {
    const { id } = useParams();
    return id ? <RatesForm formType="edit" currentRateId={id} /> : <div>Loading...</div>;
};

export default EditRatePage;